export namespace Spacing {
  export const xsmall = '8px';
  export const small = '15px';
  export const medium = '25px';
  export const large = '50px';
  export const xlarge = '100px';
}
